import React, {ChangeEvent, useEffect, useState} from 'react'
import {connect} from 'react-redux'
import {
  FlexBox,
  Form,
  Grid,
  Input,
  Panel,
  Columns,
  InputType,
  ComponentSize,
  ComponentStatus,
  FlexDirection,
} from '@influxdata/clockface'
import AWSLogoColor from '../ProviderRegion/AWSLogoColor'
import MarketplaceRegionPanelContents from '../ProviderRegion/MarketplaceRegionPanelContents'
import NotificationFlag from './NotificationFlag'
import SplashCTA from './SplashCTA'
import SplashSectionHeading from './SplashSectionHeading'
import {Marketplace} from 'js/types/marketplace'
import {State, Provider} from 'js/types'
import {getProviderInfo} from '../ProviderRegion/selectors'
import GCPLogoWithText from '../ProviderRegion/GCPLogoWithText'
import AzureLogoWithText from '../ProviderRegion/AzureLogoWithText'
import {isFlagEnabled} from '../FeatureFlags/FeatureFlag'

const marketplaceLogo = (marketplace) => {
  switch (marketplace) {
    case 'aws':
      return <AWSLogoColor className="aws-marketplace" />
    case 'gcm':
      return <GCPLogoWithText />
    case 'azure':
      return <AzureLogoWithText />
  }
}
interface PassedProps {
  buttonStatus: ComponentStatus
  company: string
  companyError: string
  organization: string
  organizationError: string
  firstName: string
  firstNameError: string
  lastName: string
  lastNameError: string
  handleChangeCompany: (event: ChangeEvent<HTMLInputElement>) => void
  handleChangeOrganization: (e: ChangeEvent<HTMLInputElement>) => void
  handleChangeFirstName: (e: ChangeEvent<HTMLInputElement>) => void
  handleChangeLastName: (e: ChangeEvent<HTMLInputElement>) => void
  marketplace: Marketplace
}

interface StateProps {
  selectedProvider: Provider
}

type Props = PassedProps & StateProps

const MarketplaceSplashContents = ({
  buttonStatus,
  company,
  companyError,
  organization,
  organizationError,
  firstName,
  firstNameError,
  lastName,
  lastNameError,
  handleChangeCompany,
  handleChangeOrganization,
  handleChangeFirstName,
  handleChangeLastName,
  marketplace,
  selectedProvider,
}: Props): JSX.Element => {
  const [showNotification, toggleNotification] = useState<boolean>(false)

  useEffect(() => {
    toggleNotification(true)
    setTimeout(() => toggleNotification(false), 4500)
  }, [])

  return (
    <>
      <Grid.Row className="sign-up--splash marketplace-splash">
        <Grid.Column
          widthSM={Columns.Ten}
          offsetSM={Columns.One}
          widthMD={Columns.Ten}
          offsetMD={Columns.One}
        >
          <input
            name="provider"
            type="hidden"
            value={selectedProvider}
            data-testid="marketplace-splash--provider"
          />
          <Panel className="marketplace-splash--panel">
            <Panel.Body size={ComponentSize.Medium}>
              {isFlagEnabled('auth0UniversalLoginEnabled', 'true') && (
                <>
                  <SplashSectionHeading title="Personal Information" />
                  <FlexBox
                    direction={FlexDirection.Row}
                    margin={ComponentSize.Large}
                  >
                    <Form.Element
                      label="First Name"
                      errorMessage={firstNameError}
                    >
                      <Input
                        name="firstName"
                        testID="firstName--input"
                        value={firstName}
                        type={InputType.Text}
                        size={ComponentSize.Medium}
                        status={
                          firstNameError
                            ? ComponentStatus.Error
                            : ComponentStatus.Default
                        }
                        onChange={handleChangeFirstName}
                      />
                    </Form.Element>
                    <Form.Element
                      label="Last Name"
                      errorMessage={lastNameError}
                      style={{whiteSpace: 'nowrap', marginTop: '0px'}}
                    >
                      <Input
                        name="lastName"
                        testID="lastName--input"
                        value={lastName}
                        type={InputType.Text}
                        size={ComponentSize.Medium}
                        status={
                          lastNameError
                            ? ComponentStatus.Error
                            : ComponentStatus.Default
                        }
                        onChange={handleChangeLastName}
                      />
                    </Form.Element>
                  </FlexBox>
                </>
              )}

              <SplashSectionHeading title="Workspace Details" />
              <FlexBox
                direction={FlexDirection.Row}
                margin={ComponentSize.Large}
              >
                <Form.Element
                  label="Account"
                  helpText="Your company name"
                  errorMessage={companyError}
                >
                  <Input
                    name="company"
                    testID="company--input"
                    value={company}
                    type={InputType.Text}
                    size={ComponentSize.Medium}
                    status={
                      companyError
                        ? ComponentStatus.Error
                        : ComponentStatus.Default
                    }
                    onChange={handleChangeCompany}
                  />
                </Form.Element>
                <Form.Element
                  label="Organization"
                  helpText="Your first organization or project in your account"
                  errorMessage={organizationError}
                >
                  <Input
                    name="orgName"
                    testID="orgName--input"
                    placeholder="Dev Team, US Eastern Region, Staging"
                    value={organization}
                    type={InputType.Text}
                    size={ComponentSize.Medium}
                    status={
                      organizationError
                        ? ComponentStatus.Error
                        : ComponentStatus.Default
                    }
                    onChange={handleChangeOrganization}
                  />
                </Form.Element>
              </FlexBox>

              <SplashSectionHeading
                title="Choose a Region"
                subtitle="This is where we will store your time series data."
              />
              {marketplaceLogo(marketplace)}
              <MarketplaceRegionPanelContents />
            </Panel.Body>
          </Panel>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <SplashCTA status={buttonStatus} />
      </Grid.Row>
      <NotificationFlag show={showNotification} />
    </>
  )
}

const mstp = (state: State): StateProps => ({
  selectedProvider: getProviderInfo(state).provider,
})

export default connect(mstp)(MarketplaceSplashContents)
